/* Allorn 2026 — conversion behaviour: guide picker tabs and the sticky buy bar. */
(() => {
  /* ---------- Guide picker (tabs pattern) ---------- */
  const initPicker = (picker) => {
    if (picker.dataset.ready) return;
    picker.dataset.ready = '1';
    const tabs = [...picker.querySelectorAll('[role="tab"]')];
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const panel = picker.querySelector(`#${t.getAttribute('aria-controls')}`);
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', (event) => {
        const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
        if (event.key in keys) {
          event.preventDefault();
          select(tabs[(i + keys[event.key] + tabs.length) % tabs.length], true);
        } else if (event.key === 'Home') { event.preventDefault(); select(tabs[0], true); }
        else if (event.key === 'End') { event.preventDefault(); select(tabs[tabs.length - 1], true); }
      });
    });
  };

  /* ---------- Sticky buy bar: shows after the hero, hides near the footer ---------- */
  const initBuybar = (bar) => {
    if (bar.dataset.ready) return;
    bar.dataset.ready = '1';
    const hero = document.querySelector('[data-al-hero]');
    const footer = document.querySelector('.footer, footer');
    let pastHero = false;
    let nearEnd = false;
    const sync = () => {
      const show = pastHero && !nearEnd;
      bar.classList.toggle('is-visible', show);
      bar.inert = !show;
      bar.setAttribute('aria-hidden', String(!show));
    };
    if (hero) new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting && e.boundingClientRect.top < 0; sync(); }).observe(hero);
    else pastHero = true;
    if (footer) new IntersectionObserver(([e]) => { nearEnd = e.isIntersecting; sync(); }).observe(footer);
    sync();
  };


  /* ---------- Teddy's stories: play in view, one at a time, tap for sound ---------- */
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const initStories = (wrap) => {
    if (wrap.dataset.ready) return;
    wrap.dataset.ready = '1';
    const videos = [...wrap.querySelectorAll('.al-story-card__video')];
    const load = (v) => { if (!v.src && v.dataset.src) v.src = v.dataset.src; };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        const v = e.target;
        if (e.isIntersecting && e.intersectionRatio > 0.6) {
          load(v);
          if (!reduce) v.play().catch(() => {});
        } else {
          v.pause();
        }
      });
    }, { threshold: [0, 0.6, 1] });
    videos.forEach((v) => io.observe(v));
    wrap.querySelectorAll('[data-al-sound]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const v = btn.closest('.al-story-card__media').querySelector('video');
        const turnOn = btn.getAttribute('aria-pressed') !== 'true';
        videos.forEach((o) => { o.muted = true; });
        wrap.querySelectorAll('[data-al-sound]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
        load(v);
        v.muted = !turnOn;
        btn.setAttribute('aria-pressed', String(turnOn));
        if (turnOn) { v.currentTime = 0; v.play().catch(() => {}); }
      });
    });
  };

  /* ---------- Hero phone tilt on pointer ---------- */
  const initTilt = (stage) => {
    if (stage.dataset.ready || reduce) return;
    stage.dataset.ready = '1';
    const media = stage.querySelector('.al-stage__media');
    const hero = stage.closest('[data-al-hero]') || stage;
    hero.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse' || !media) return;
      const r = hero.getBoundingClientRect();
      media.style.setProperty('--tilt-y', `${((e.clientX - r.left) / r.width - 0.5) * 14}deg`);
      media.style.setProperty('--tilt-x', `${-((e.clientY - r.top) / r.height - 0.5) * 10}deg`);
    });
    hero.addEventListener('pointerleave', () => { media?.style.removeProperty('--tilt-y'); media?.style.removeProperty('--tilt-x'); });
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-al-picker]').forEach(initPicker);
    root.querySelectorAll('[data-al-buybar]').forEach(initBuybar);
    root.querySelectorAll('[data-al-stories]').forEach(initStories);
    root.querySelectorAll('[data-al-tilt]').forEach(initTilt);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
